export default __webpack_public_path__ + "static/media/spring.f6e91e60.png";